<template>
  <div v-loading="loading">
    <div class="preview-wrap">
      <div class="container">
        <p class="container-title">卖方交收申请表</p>
        <table class="my-table" cellspacing="0" cellpadding="0">
          <tr>
            <td width="80px">
              <span>会员号</span>
            </td>
            <td width="80px">
              <span>分客户号</span>
            </td>
            <td width="100px">
              <span>合同号</span>
            </td>
            <td width="80px">
              <span>价格</span>
            </td>
            <td width="80px">
              <span>数量（吨）</span>
            </td>
            <td width="80px">
              <span>品牌</span>
            </td>
            <td width="80px">
              <span>等级</span>
            </td>
            <td width="80px">
              <span>升贴水单价</span>
            </td>
            <td>
              <span>交货地</span>
            </td>
            <td width="200px">
              <span>开具增值税票单位</span>
            </td>
          </tr>
          <tr v-for="(item, index) in deliveryDataList" :key="index">
            <td>
              <span>{{ orderData.sellerAccount }}</span>
            </td>
            <td>
              <span>{{ item.splitUserAccount }}</span>
            </td>
            <td>
              <span>{{ item.contractCode }}</span>
            </td>
            <td>
              <span>{{ item.price }}</span>
            </td>
            <td>
              <span>{{ item.quantity }}</span>
            </td>
            <td>
              <span>{{ orderData.brandName }}</span>
            </td>
            <td>
              <span>{{ orderData.grade }}</span>
            </td>
            <td>
              <span>{{ orderData.areaPrice }}</span>
            </td>
            <td>
              <span>{{ orderData.deliveryAddress }}</span>
            </td>
            <td>
              <span>{{ orderData.sellerName }}</span>
            </td>
          </tr>
          <tr class="move">
            <td colspan="12" class="text-left">
              <span>移库选择：</span>
              <span v-for="(item, index) in $key.myOrder.moveWarehouseType" :key="index">
                <label :for="item.id">{{ item.name }}</label>
                <input type="checkbox" :id="item.id" :value="item.id" v-model="moveWarehouseType">
              </span>
              <div style="display: inline">
                <span>其他</span>
                <div style="display: inline-block;">
                  <input type="text" v-model="other" class="other" maxlength="6">
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="6" class="text-left">
              <div>
                <span>备注：{{ orderData.remark }}</span>
              </div>
            </td>
            <td colspan="6" class="text-left" style="text-indent: 32px;">
              <div>
                <span>同意贵市场买方会员有在最后交收日后十个工作日内对交收食糖的质量问题追索的权利</span>
              </div>
            </td>
          </tr>
        </table>
        <div class="sing-info-wrap">
          <div class="sign">会员签章：</div>
          <div class="date">日期：</div>
        </div>
      </div>
    </div>
    <div class="button-wrap no-print">
      <el-button type="primary" @click="download">下载</el-button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'preview',
  data () {
    return {
      orderData: [], // 订单信息
      deliveryDataList: [], // 交收信息
      moveWarehouseType: [], // 移仓选择
      other: '', // 移库选择的其它
      loading: false
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    // 获取交收单数据
    getData () {
      this.loading = true
      const url = this.$API.myOrder.mySellerDeliveryDetail
      const param = {
        id: this.$route.params.id
      }
      this.$http.post(url, param).then(res => {
        this.loading = false
        this.orderData = res.data
        this.moveWarehouseType = [this.orderData.moveWarehouseType] // 移仓选择
        this.deliveryDataList = this.orderData.contangoOrderDeliveryDetailList // 交收信息
      }).catch(() => {
        this.loading = false
      })
    },
    // 下载（即打印）
    download () {
      this.$utils.print()
    }
  }
}
</script>

<style lang="scss" scoped>
  .preview-wrap{
    display: flex;
    justify-content: center;
    overflow: hidden;
    .container {
      width: 1200px;
      overflow: hidden;
      margin-top: 60px;
    }
    .container-title {
      text-align: center;
      font-size:28px;
      font-weight: bold;
      line-height: 50px;
      letter-spacing: 8px;
    }
    .my-table {
      border: 1px solid black;
      width: 100%;
      text-align: center;
    }
    .my-table td {
      padding: 5px;
      border: 1px solid black
    }
    .move div {
      display: inline;
    }
    .move {
      text-align: center;
    }
    .select_box {
      display: inline-block;
      width:10px;
      height:10px;
      border:1px solid black;
      position: relative;
      margin-right: 10px;
    }
    .select_box > span {
      position: absolute;
      left:0;
      top:-5px;
    }
    .bottom_text {
      float: right;
      margin-right: 20px;
    }
    .weight{
      font-weight: bold;
    }
  }
  input[type='checkbox']{
    zoom: 1.5;
    vertical-align: text-top;
    margin: 0 8px;
  }
  .other{
    height: 28px;
    width: 100px;
    border: none;
    border-bottom: 1px solid black;
    margin-left: 5px;
    font-size: 16px;
    line-height: 28px;
  }
  .text-left{
    text-align: left;
    text-indent: 8px;
  }
  .sing-info-wrap{
    float: right;
    overflow: hidden;
    line-height: 35px;
    margin-top: 40px;
    .sign{
      margin-right: 300px;
    }
  }
  .button-wrap{
    width: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media print{
    .no-print{
      display: none;
    }
  }
  @page {
    size: A4 landscape;
  }
  @page:right {
    margin-left: 30px;
  }
</style>
